import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ClientRegular } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'client-regular-status',
  templateUrl: './client-regular-status.component.html',
  styleUrls: ['./client-regular-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class ClientRegularStatusComponent implements OnInit {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  constructor() {}

  regularStatus: any = ClientRegular;

  ngOnInit(): void {}
}
